/**
 * Diretiva responsável por trazer o foco para o elemento da interface visual que a utiliza.
 */

angular.module("avlib").directive('avFocusMe', ["$timeout", "$parse", function($timeout, $parse){
	return {
		link: function (scope, element, attrs) {
			var model = $parse(attrs.avFocusMe);
			scope.$watch(model, function (value) {
				$timeout(function () {
					element[0].focus();
					// sem estes 200 ms adicionais estavam acontecendo casos em que o foco não era aplicado
				}, 200);
			});		
		}
	}
}]);
